import {Action} from '@ngrx/store';
import {DynForm} from '../domain/meta/dyn-form';
import {DynFormData} from '../domain/data';

export const UPDATE                 = '[FormEditor] Update Value';
export const BUILD_FORM             = '[FormEditor] Build Form';
export const BUILD_FORM_SUCCESS     = '[FormEditor] Build Form Success';
export const BUILD_FORM_FAIL        = '[FormEditor] Build Form Fail';
export const RESET_FORM             = '[FormEditor] Reset Form';

export class Update implements Action {
    readonly type = UPDATE;
    constructor(public payload: {
        value: any,
        status: boolean
    }) { }
}

export class BuildForm implements Action {
    readonly type = BUILD_FORM;
    constructor() { }
}

export class BuildFormSuccess implements Action {
    readonly type = BUILD_FORM_SUCCESS;
    constructor(public form: DynForm) { }
}

export class BuildFormFaild implements Action {
    readonly type = BUILD_FORM_FAIL;
    constructor(error: string) { }
}

export class ResetForm implements Action {
    readonly type = RESET_FORM;
    constructor() { }
}

export type FormEditorActions
    = Update
    | BuildForm
    | BuildFormSuccess
    | ResetForm;



// WEBPACK FOOTER //
// ./src/app/forms/state/form-editor.actions.ts